import React, { useState } from "react";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import Button, {
  buttonThemes
} from "@streeteasy/design-system/deprecated/actions/button";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import { VisuallyHidden } from "@streeteasy/design-system/style-utilities/visually-hidden";
import { bool, number, oneOf, string } from "prop-types";

import { saveButtonVersions } from "../../constants";
import { useCreateListingJourney, useStopListingJourney } from "../../hooks";
import * as S from "./styled";

const SaveButton = props => {
  const { buttonVersion, isActive, listingId, listingType } = props;
  const [listingJourneyId, setListingJourneyId] = useState(
    props.listingJourneyId
  );
  const [isSaved, setIsSaved] = useState(isActive);
  const mutationVariables = { listingId, listingType, listingJourneyId };

  const [stopListingJourney] = useStopListingJourney(mutationVariables, () => {
    setListingJourneyId(null);
    setIsSaved(false);
  });

  const [createListingJourney] = useCreateListingJourney(
    mutationVariables,
    ({ id }) => {
      setListingJourneyId(id);
      setIsSaved(true);
    }
  );

  const buttonText = isSaved ? "Saved" : "Save";
  const handleClick = isSaved ? stopListingJourney : createListingJourney;
  const iconClass = isSaved ? "heart" : "heart-o";

  return (
    <>
      {buttonVersion === saveButtonVersions.classic && (
        <S.Wrapper>
          <Button
            onClick={handleClick}
            size={componentSizes.MD}
            style={{ minWidth: 191, flex: 1 }}
            theme={buttonThemes.SECONDARY}
          >
            <FontAwesomeIcon color="primary" iconClass={iconClass} />
            <span>{buttonText}</span>
          </Button>
        </S.Wrapper>
      )}
      {buttonVersion === saveButtonVersions.heart && (
        <S.HeartButton onClick={handleClick}>
          <VisuallyHidden>{buttonText}</VisuallyHidden>
          <S.HeartIcon iconClass={iconClass} />
        </S.HeartButton>
      )}
    </>
  );
};

SaveButton.propTypes = {
  buttonVersion: oneOf(Object.values(saveButtonVersions)),
  listingId: number.isRequired,
  listingType: string.isRequired,
  listingJourneyId: number,
  isActive: bool
};

SaveButton.defaultProps = {
  buttonVersion: saveButtonVersions.classic,
  listingJourneyId: null,
  isActive: true
};

export default SaveButton;
